



import { Component, Prop } from 'vue-property-decorator';
import EntityType from "@/models/Shared/EntityType";
import ComponentLocation from '@/models/Shared/ComponentLocation';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PageRoutes from '@/router/PageRoutes';

@Component({ name: 'OpenEntityInCurrentWindowLink' })
export default class extends SaascadaVue {

    @Prop()
    location: ComponentLocation;

    @Prop({required: true})
    entityId: string;

    @Prop({required: true})
    entityType: EntityType;

    @Prop({required: true})
    entityName: string;

    get url() {
        switch (this.entityType) {
            case EntityType.DepositAccount:
                return PageRoutes.DepositAccount.replace(":id", this.entityId);
            case EntityType.LendingAccount:
                return PageRoutes.LendingAccount.replace(":id", this.entityId);
            case EntityType.Person:
                return PageRoutes.Person.replace(":id", this.entityId);
            case EntityType.Organisation:
                return PageRoutes.Organisation.replace(":id", this.entityId);
            case EntityType.Customer:
                return PageRoutes.Customer.replace(":id", this.entityId);
            case EntityType.Product:
                return PageRoutes.Product.replace(":id", this.entityId);
            case EntityType.ProductIssue:
                return PageRoutes.ProductIssue.replace(":id", this.entityId);
            case EntityType.ProductMigration:
                return PageRoutes.ProductMigration.replace(":id", this.entityId);
            case EntityType.RateSource:
                return PageRoutes.RateSource.replace(":id", this.entityId);
            default:
                break;
        }
  }

}
